'use client'

import dynamic from 'next/dynamic'

/**
 * Lazy ContactFormModal — code-split the modal (and its form deps) out of the
 * initial client bundle. It renders nothing until opened, so `ssr: false` has no
 * SEO/visual cost; the chunk loads on the client instead of inflating first load.
 */
export const ContactFormModal = dynamic(
  () => import('@/components/ContactFormModal.client').then((m) => m.ContactFormModal),
  { ssr: false },
)
